import React from 'react';
import { useDailyQuote } from '../../hooks/useDailyQuote';
import styles from './Apps.module.css';

/** 오늘의 메모와 한마디 */
export const Notes: React.FC = () => {
    const quote = useDailyQuote();

    return (
        <div className={styles.notes}>
            <p className={styles.noteTitle}>Today’s Note</p>
            <p className={styles.noteBody}>Focus. Build. Ship.</p>
            <p className={styles.noteQuote}>{quote}</p>
        </div>
    );
};

export default Notes;
